import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Grid2, Typography } from '@mui/material'
import BackImage from '../assets/images/back.svg';

function HeaderBack(props) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);  
  };

  return (                                             
    <Grid2 className='header_details' height={"221px"} sx={{ backgroundImage: `url("${props.eventimg}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <Grid2 className='menu-Link' component={Link}  onClick={!props.backdisable ? handleBackClick : null}  style={{ cursor: props.backdisable ? 'not-allowed' : 'pointer', opacity: props.backdisable ? 0.5 : 1 }}>
        <img src={BackImage} alt="Navbar" width={180} />
      </Grid2>
      <Typography className='categories-name'>{props.name}</Typography>
      <Grid2 className="back-shadow-img"></Grid2>
    </Grid2>
  );
}

export default HeaderBack;
